import { Reducer } from 'react';
import { StateChangesViewState } from 'store/analytics/ui/analyticsUiTypes';

import {
  SELECT_STATE_CHANGES_VIEW_TRIGGER,
  SET_STATE_CHANGES_ACTIVE_PAGE,
  SET_STATE_CHANGES_PAGE_SIZE,
  SET_STATE_CHANGES_SEARCH_KEYWORD,
  StateChangesActionTypes,
} from 'store/analytics/ui/subViews/stateChangesView/stateChangesActionTypes';

export const initialStateChangesViewState: StateChangesViewState = {
  activePage: 1,
  pageSize: 5,
  searchKeyword: '',
  selectedStateChangesType: null,
};

export const stateChangesViewReducer: Reducer<StateChangesViewState, StateChangesActionTypes> = (
  state = initialStateChangesViewState,
  action,
): StateChangesViewState => {
  switch (action.type) {
    case SET_STATE_CHANGES_ACTIVE_PAGE:
      return { ...state, activePage: action.payload };
    case SET_STATE_CHANGES_PAGE_SIZE:
      return { ...state, pageSize: action.payload };
    case SELECT_STATE_CHANGES_VIEW_TRIGGER:
      return { ...state, selectedStateChangesType: action.payload };
    case SET_STATE_CHANGES_SEARCH_KEYWORD:
      return { ...state, searchKeyword: action.payload };
    default:
      return state;
  }
};
